// extracted by mini-css-extract-plugin
export var actionText = "_m1-4";
export var container = "_m1-0";
export var leftSection = "_m1-1";
export var rightSection = "_m1-2";
export var settingsButton = "_m1-6";
export var settingsIcon = "_m1-7";
export var shortcut = "_m1-5";
export var shortcutGroup = "_m1-3";